module.exports = __webpack_public_path__ + "img/fmn-logo.b8c4995c.png";